import { GET_REQUESTED } from '../../../../../services/core/reducerFactory/types';

export default {
  SELECT_PAGE: GET_REQUESTED.replace('*', 'eventsMSP')
};
